/* import __COLOCATED_TEMPLATE__ from './dds-multiplier.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type CircuitService from 'simdds/services/circuit';

const popoverSizingHelper = function (count: number, max: number) {
  const columns = count <= 8 ? 1 : Math.floor(Math.sqrt(count) * 0.8);
  return Math.min(columns * 64 + 5, max);
};
interface DDSMultiplierSignature {
  Element: HTMLDivElement;
}
export default class DDSMultiplier extends Component<DDSMultiplierSignature> {
  @service declare circuit: CircuitService;
  times = 'x';
  popoverSizing = popoverSizingHelper;

  get above20Mult() {
    return this.circuit.partData?.multipliers ? this.circuit.partData.multipliers.length > 20 : false;
  }
  get multipliers() {
    const multipliers = this.circuit.partData?.multipliers;
    return multipliers ? [1].concat(multipliers) : [1];
  }
  @action localSetMultiplier(value: number) {
    this.circuit.multiplier = value;
    document.getElementById('multiplier_dropdown_menu')?.hidePopover();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DdsMultiplier: typeof DDSMultiplier;
  }
}
